import React, { useEffect, useRef } from "react";
import { useDispatch } from "react-redux";
import { commonConstants } from "../../_redux/_constants";
import { isUserLoggin } from "../../_helpers/auth.helper";
import {
  logoutAuthRequest,
  setMultipleTabOpen,
} from "../../_redux/_actions/auth.actions";

/**
 * Runs at app root so it mounts on every tab (including login page).
 * Ensures multi-tab detection works even when the new tab is redirected to login
 * (no sessionStorage): this tab still announces itself so the existing tab can logout.
 */
const MultiTabHandler = () => {
  const dispatch = useDispatch();
  const broadcastLogoutRef = useRef(false);

  useEffect(() => {
    const channel = new BroadcastChannel(
      commonConstants.BROADCAST_CHANNEL_LOLC_OB,
    );

    channel.postMessage(commonConstants.IS_MULTIPLE_TAB_OPEN);

    channel.onmessage = (event) => {
      if (event.data === commonConstants.IS_MULTIPLE_TAB_OPEN) {
        if (!broadcastLogoutRef.current) {
          channel.postMessage(commonConstants.LOGOUT_NEW_TAB);
        }

        dispatch(setMultipleTabOpen(true));

        broadcastLogoutRef.current = true;
      }
      if (event.data === commonConstants.LOGOUT_NEW_TAB) {
        if (isUserLoggin()) {
          dispatch(logoutAuthRequest());
        }
        channel.postMessage(commonConstants.IS_MULTIPLE_TAB_LOGGED_OUT);
      }
    };

    return () => {
      channel.close();
      // window.removeEventListener("storage", handleStorageChange);
    };
  }, [dispatch]);

  return null;
};

export default MultiTabHandler;
